import { throwErrorWithId } from '@pypestream/utils';

import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { getBotWithAssets } from '../../utils';

export const updateAssets = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  selectedBot: ProStudioContext['selectedBot'];
  cb?: (assets: { id: string; url: string }[]) => void;
} | void> => {
  let callback: ((assets: { id: string; url: string }[]) => void) | undefined;

  if (event.type === 'updateAssets') {
    callback = event.cb;
  }

  const { selectedBot, project } = ctx;

  const projectId = project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  if (!selectedBot) {
    throwErrorWithId('Selected bot is required');
    return;
  }

  const botWithAssets = await getBotWithAssets({
    selectedBot,
    projectId,
  });

  return {
    selectedBot: botWithAssets,
    cb: callback,
  };
};
